module.exports = __webpack_public_path__ + "img/map-mark-1.273e3dc9.png";